var compare_ids = [];




if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(valueToFind, fromIndex) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      // 1. Let O be ? ToObject(this value).
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(valueToFind, elementK) is true, return true.
        if (sameValueZero(o[k], valueToFind)) {
          return true;
        }
        // c. Increase k by 1.
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}




jQuery(document).ready(function() {

  // Initialize compare list from cookie
  var json_str = readCookie('compare_ids');
  if (json_str !== null) {
    compare_ids = JSON.parse(json_str);
  }

  // If there is some ids stored, show the UI.
  if (compare_ids !== null && compare_ids.length > 0) {
    console.log('Has compare iDS!');
    // Show UI
    jQuery('.products-compare-widget').show();
    jQuery('#pc-num').html(compare_ids.length);
  }


  // When a facet refreshes, show which products are in list
  jQuery(document).on('facetwp-loaded', function() {
    initializeProductsCompare();
    updateProductListCompares();
  });
});









function initializeProductsCompare() {

  // Add or remove item to compare list
  jQuery(".compare-add").on("click", function(e) {
    var id = jQuery(this).attr('data-id');

    // If it's not in the list, add it.
    if (!compare_ids.includes(id)) {

      console.log(compare_ids);

      compare_ids.push(id);
      console.log('Adding....');
      console.log(compare_ids);

      // Create/update cookie.
      var json_str = JSON.stringify(compare_ids);
      createCookie('compare_ids', json_str, 3);

      // Update counter
      jQuery('.products-compare-widget').show();
    } else {

      var index = compare_ids.indexOf(id);
      if (index > -1) {
        compare_ids.splice(index, 1);
        console.log('removing entry');
      }

      // Create/update cookie.
      var json_str = JSON.stringify(compare_ids);
      createCookie('compare_ids', json_str, 3);
    }

    jQuery('#pc-num').html(compare_ids.length);
    updateProductListCompares();
  });

  // Clicking on compare button
  jQuery("button#compare-products").on("click", function(e) {
    var ids_str = compare_ids.join(',');
    window.location.href = '/products-compare?ids=' + ids_str;
  });

  // Clicking on clear list
  jQuery("#clear-product-list").on("click", function(e) {
    compare_ids = [];
    eraseCookie('compare_ids');
    jQuery('.products-compare-widget').hide();
    jQuery('#pc-num').html('0');

    updateProductListCompares();

    return false;
  });
}



function updateProductListCompares() {
  jQuery('ul.products li').each(function() {
    var id = jQuery(this).find('button.compare-add').attr('data-id');
    if (compare_ids.includes(id)) {
      jQuery(this).find('button.compare-add').addClass('selected');
      jQuery(this).find('button.compare-add').html('- Remove from compare list');
    } else {
      jQuery(this).find('button.compare-add').removeClass('selected');
      jQuery(this).find('button.compare-add').html('+ Compare');
    }
  });

  // If there are no ids, hide the ui
  if (compare_ids.length <= 0) {
    jQuery('.products-compare-widget').hide();
  }
}









function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}
